import { PluginKey } from '@atlaskit/editor-prosemirror/state';

import type { AISpeechToTextPluginState } from './types/AISpeechToTextPluginState';

export const aiSpeechToTextPluginKey = new PluginKey<AISpeechToTextPluginState>('aiSpeechToText');
